import { Box, Typography, useTheme } from "@mui/material";
import { useLocale } from "next-intl";

interface VoteResultBarProps {
  proCount: number;
  conCount: number;
  noLabel?: boolean;
  width?: number | string;
  height?: number | string;
}

function VoteResultBar({ proCount, conCount, noLabel = false, width = "100%", height = 10 }: VoteResultBarProps) {
  const theme = useTheme();
  const total = proCount + conCount;
  const proPercent = total > 0 ? (proCount / total) * 100 : 50;
  const conPercent = total > 0 ? (conCount / total) * 100 : 50;

  const labelSpacing = 9;

  const locale = useLocale();
  const formatter = new Intl.NumberFormat(locale); // 여기서 포맷터 생성

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width,
        height,
        padding: !noLabel ? `0 ${labelSpacing * 5}px` : 0,
      }}
    >
      {/* Pro 퍼센트 라벨 (왼쪽 끝) */}
      {!noLabel && (
        <Typography
          variant="caption"
          sx={{
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            display: "flex",
            alignItems: "center",
            paddingRight: `${labelSpacing}px`,
          }}
        >
          {Math.round(proPercent)}%
        </Typography>
      )}

      {/* Pro 바 */}
      <Box
        sx={{
          position: "absolute",
          right: "50%",
          width: `${proPercent}%`,
          maxWidth: !noLabel ? `calc(50% - ${labelSpacing * 4}px)` : "50%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          pr: noLabel ? 0.5 : 0,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            right: 0,
            width: "100%",
            height: "80%",
            background: "#1E9E23",
            borderRadius: "4px 0 0 4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            pr: 0.5,
          }}
        >
          {!noLabel && (
            <Typography
              variant="caption"
              sx={{
                color: "white",
                fontWeight: 300,
                fontSize: "0.55rem",
              }}
            >
              {formatter.format(proCount)}
            </Typography>
          )}
        </Box>
      </Box>

      {/* 중간선 */}
      <Box
        sx={{
          width: 2,
          height: "100%",
          backgroundColor: theme.palette.grey[100],
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 2,
        }}
      />

      {/* Con 바 */}
      <Box
        sx={{
          position: "absolute",
          left: "50%",
          width: `${conPercent}%`,
          maxWidth: !noLabel ? `calc(50% - ${labelSpacing * 4}px)` : "50%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          pl: noLabel ? 0.5 : 0,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            left: 0,
            width: "100%",
            height: "80%",
            background: "#F01616",
            borderRadius: "0 4px 4px 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            pl: 0.5,
          }}
        >
          {!noLabel && (
            <Typography
              variant="caption"
              textAlign={"center"}
              sx={{
                color: "white",
                fontWeight: 300,
                fontSize: "0.55rem",
              }}
            >
              {formatter.format(conCount)}
            </Typography>
          )}
        </Box>
      </Box>

      {/* Con 퍼센트 라벨 (오른쪽 끝) */}
      {!noLabel && (
        <Typography
          variant="caption"
          sx={{
            position: "absolute",
            right: 0,
            top: "50%",
            transform: "translateY(-50%)",
            display: "flex",
            alignItems: "center",
            paddingLeft: `${labelSpacing}px`,
          }}
        >
          {Math.round(conPercent)}%
        </Typography>
      )}
    </Box>
  );
}

export default VoteResultBar;
